import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/order/shopping-carts";

export default {
  get() {
    return Client.get(`${resource}`);
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  delete(payload) {
    return Client.post(`${resource}/delete`, payload);
  },
};
